export type EstacionSyncValue = 'verano' | 'allseason' | 'invierno'

const TEMPORADA = {
  VERANO: 'verano',
  ALLSEASON: 'allseason',
  INVIERNO: 'invierno',
} as const satisfies Record<string, EstacionSyncValue>

/** Landings (invierno, cuatro-estaciones…) preseleccionen temporada al legacy selector. */
export function resolveEffectiveEstacion(
  selectedEstacion: EstacionSyncValue | null,
  legacyTemporada: EstacionSyncValue | null,
  legacyTemporadaLocked: boolean
): EstacionSyncValue {
  if (legacyTemporadaLocked && legacyTemporada) return legacyTemporada
  return selectedEstacion ?? legacyTemporada ?? TEMPORADA.VERANO
}
